import { render, staticRenderFns } from "./IpAddressesTab.vue?vue&type=template&id=d9b553ae&scoped=true&"
import script from "./IpAddressesTab.vue?vue&type=script&lang=js&"
export * from "./IpAddressesTab.vue?vue&type=script&lang=js&"
import style0 from "./IpAddressesTab.vue?vue&type=style&index=0&id=d9b553ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b553ae",
  null
  
)

export default component.exports